import React from 'react';

import {
  FeatureCategories,
  FrameFilterItems,
  GridFilterItems,
} from 'src/modules/designStudio/constants';
import {
  DesignConfig,
  WindowParametricProperties,
} from 'src/modules/designStudio/types';

import { UpdateDesignFunction } from '../../../providers/HistoryProvider';
import { ColorList } from '../Filters/ColorList';
import { WindowFilter } from '../Filters/WindowFilter';

export const WindowMenu = ({
  designConfig,
  updateDesign,
}: {
  designConfig: DesignConfig;
  updateDesign: UpdateDesignFunction;
}) => {
  const { color } = designConfig[FeatureCategories.WINDOW] as {
    color: string | null;
  };

  const isWindowConfigEmpty = !!designConfig.WINDOWS[
    WindowParametricProperties.GRID_TYPE
  ];

  return (
    <>
      <WindowFilter
        designConfig={designConfig}
        items={FrameFilterItems}
        title="Window Types"
        updateDesign={updateDesign}
        windowDesignConfigProperty={WindowParametricProperties.FRAME_TYPE}
      />
      {!isWindowConfigEmpty ? null : (
        <>
          <WindowFilter
            designConfig={designConfig}
            items={GridFilterItems}
            title="Grid Style"
            updateDesign={updateDesign}
            windowDesignConfigProperty={WindowParametricProperties.GRID_TYPE}
          />
          <ColorList
            color={color}
            designConfig={designConfig}
            designConfigCategory={FeatureCategories.WINDOW}
            updateDesign={updateDesign}
          />
        </>
      )}
    </>
  );
};
